export function initTabs() {
  const tabButtons = document.querySelectorAll(".tab__button");
  const tabContents = document.querySelectorAll(".tab__content");
  const background = document.querySelector(".background");

  function switchTab(targetId) {
    const targetButton = document.querySelector(`.tab__button[data-tab="${targetId}"]`);
    if (!targetButton) return;

    // Handle tabs
    tabButtons.forEach(btn => btn.classList.remove("is-active"));
    tabContents.forEach(content => content.classList.remove("is-active"));
    targetButton.classList.add("is-active");
    document.getElementById(targetId)?.classList.add("is-active");

    // Handle background grayscale
    if (targetId === "past-highlights") {
      background?.classList.add("grayscale");
    } else if (targetId === "upcoming") {
      background?.classList.remove("grayscale");
    }
  }

  // Handle click events
  tabButtons.forEach(button => {
    button.addEventListener("click", () => {
      const targetId = button.dataset.tab;
      switchTab(targetId);
      // Update URL without scrolling
      // history.pushState(null, '', `#${targetId}`);
    });
  });

  // Check URL hash on page load
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1); // Remove the # symbol
    switchTab(targetId);
    setTimeout(function() {
      window.scrollTo(0, 0);
    }, 100);
  }

  // Listen for hash changes
  window.addEventListener('hashchange', () => {
    const targetId = window.location.hash.substring(1);
    switchTab(targetId);
  });
}